module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('h2', {
    staticClass: "titlePageAuthor",
    attrs: {
      "id": "tp"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("ARI FLEISCHER")])]), _vm._v(" "), _c('h2', {
    staticClass: "titlePageTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TAKING")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "titlePageText"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The President, the Press, and"), _c('br'), _vm._v("\nMy Years in the White House")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', {
    staticClass: "titlePageTitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("HEAT")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "logo.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12665897","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780061755149_title.vue
// module id = 60
// module chunks = 0